import ChildCollection from './childCollection.js';
export default ChildCollection;
